import { render } from "./login.vue?vue&type=template&id=bffe1f0c&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=bffe1f0c&scoped=true&lang=css"

import exportComponent from "E:\\dipto_projects\\parcel\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffe1f0c"]])

export default __exports__